import { atom } from "jotai";

export const isAuthenticatedAtom = atom<boolean>(false);
